import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';
import { LoaderService } from 'src/app/utils/loader.service';

@Component({
  selector: 'app-director-avatar',
  templateUrl: './director-avatar.component.html',
  styleUrls: ['./director-avatar.component.scss']
})
export class DirectorAvatarComponent implements OnInit {

  avatar_file;
  fileUploaded: boolean;
  image_url;

  constructor(
    public dialogref: MatDialogRef<DirectorAvatarComponent>,
    private dialog: MatDialog,
    private loaderService: LoaderService,
    private adminService: AdminService,
    private toastr: ToastrService
  ) { }

  private filesControl = new FormControl(null, FileUploadValidators.filesLimit(6));
  public demoForm = new FormGroup({
    files: this.filesControl
  });

  ngOnInit() {

    this.uploadAvatar()

  }

  close() {
    this.dialogref.close();

  }

  uploadAvatar() {
    const avatarData = this.demoForm.get('files');
    avatarData.valueChanges.subscribe(
      (res: any) => {
        this.avatar_file = res[0];
        this.fileUploaded = true;
        this.previewUploadedFile(this.avatar_file)
      }
    );
  }

  previewUploadedFile(file) {
    let url
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      this.image_url = event.target.result
    }
  }

  uploadFile() {
    let formData = new FormData()

    formData.append('company_detail[proprietor_avatar]', this.avatar_file)

    this.adminService.uploadProprietorAvatar(formData).subscribe(
      res => {
        this.loaderService.display(false)
        this.toastr.success('Your Director Avatar has been updated', 'Success');
        this.close()
      },
      err => {
        this.loaderService.display(false)
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i], 'Error');
        }
        this.close()
      }
    )

  }

}
